<template lang="pug">
    layout.contentTransparent
        div.layoutWrapper
            v-layout(row wrap)
                v-flex(xs12)

                    // Main title
                    div.titleMinutes
                      title-component(
                        type="h2"
                        slot="title"
                        :title="$t('mindfulMinutes.view.listTitle')"
                      )


        template

            v-data-iterator(
                item-key="id"
                content-tag="v-layout"
                no-data-text="No videos available"
                row
                wrap
                :items="items"
                :rows-per-page-items="[2]"
                :pagination.sync="pagination"
                :total-items="total"
            )
                template(v-slot:item="props")
                    v-flex.mt-3(xs12 md6 xl4)

                          // Banner
                          banner-component(
                            :bannerSession="props.item"
                            :isMindfulMoment="true"
                            :key="props.item.id"
                            showShareButton
                            showLikeButton
                          )

        div.bottomSpacer
</template>

<script>
    import Layout from '../../Layout/Layout';
    import Banner from '~components/Banner';
    import Title from '~components/Title';
    import { mapActions, mapGetters } from 'vuex';

    import mindfulMinute from '~api/mindfulMinute';
    import VueTypes from 'vue-types';

    import viewingTimeMixin from '~mixins/viewingTime.mixin';

    export default {
        components: {
            Layout,
            TitleComponent: Title,
            BannerComponent: Banner
        },
        mixins: [viewingTimeMixin],
        props: {
            theme: VueTypes.string.def(''),
            title: VueTypes.string.def(''),
            type: VueTypes.string.def(''),
            instructor: VueTypes.object.def({}),
            duration: VueTypes.number.def(0)
        },
        data() {
            return {
                expand: false,
                headers: this.$t('sessions.tableHeaders'),
                titleText: this.title,
                filters: {
                    type: this.type,
                    theme: this.theme
                },
                items: [],
                meditationDuration: this.duration,
                pagination: {},
                sortBy: null,
                orderBy: null,
                total: 0,
                rowsPerPage: [10],
                search: null,
                timeout: null,
                routeInitialized: false,
                isLoading: false,
                menuStartedAt: false,
                menuFinishedAt: false,
                predefinedDuration: null,
                instructors: [],
                instructorFullName: ''
            };
        },

        watch: {
            /**
             * Watch pagination and update managers data on change.
             */
            pagination: {
                async handler(paginationData) {
                    // Collect params.
                    const params = {
                        page: paginationData.page
                    };

                    // Fetch data from API.
                    const { data } = await mindfulMinute.list(params);

                    this.items = data.items;

                    this.total = data.meta.total;

                    // Stop progress bar.
                    this.isLoading = false;

                    document
                        .getElementById('app')
                        .scrollIntoView({ behavior: 'smooth' });
                },
                deep: true
            }
        },
        computed: {
            ...mapGetters('sessions', ['session']),
            ...mapGetters('auth', ['isAdmin'])
        },
        async created() {
            if (this.isAdmin) return;
            await this.read({
                id: process.env.VUE_APP_MINDFUL_MONENTS_SESSION_ID
            });
            await this.saveViewSession();
            this.initUpdateViewingTime();
        },
        /**
         * Retrieve managers
         */
        async beforeRouteEnter(to, from, next) {
            const { data } = await mindfulMinute.list();

            next(vm => {
                if (data.items && data.meta) {
                    vm.items = data.items;

                    vm.total = data.meta.total;

                    vm.pagination = {
                        page: data.meta.page,
                        rowsPerPage: data.meta.limit
                    };
                }

                vm.$nextTick(() => {
                    vm.routeInitialized = true;
                });
            });
        },
        methods: {
            ...mapActions('sessions', ['readBusinesses', 'read']),
            /**
             * Reset pagination.
             */
            resetPagination() {
                this.pagination = { ...this.pagination };
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'
    @import "../../../../assets/style/_mixins.styl"

    .createButtonWrapper
        display: flex
        justify-content: flex-end

    .text-left
        text-align: left

    .instructorName
        padding-bottom: 10px
        font-size: 12px

    .description
        position: relative

        &:before
            position: absolute
            top: 8px
            left: 105px
            content: ""
            width: 75%
            height: 1px
            background: linear-gradient(90deg, rgba(255, 255, 255, 0.35) 70%, #022341 100%)

        &:after
            position: absolute
            top: 8px
            left: 0
            content: ""
            width: 20px
            height: 1px
            background: $theme.secondary

    .title
        margin-left: 20px
        padding: 5px 10px
        background-color: $theme.primary
        font-size: 12px !important
        color: $theme.secondary

    >>> .dateHeader
        min-width: 180px
        max-width: 200px

    >>> .SessionActions
        min-width: 210px

    >>> .date-filter-input
        .v-label
        .v-label.v-label--active
            color: $theme.white

        .v-input__icon .v-icon
            color: $theme.white

        &.v-text-field > .v-input__control > .v-input__slot:after
            border-style: none

    .MeditationName
        display: flex
        padding-top: 10px

    .linkAction
        color: $theme.primary
        font-size: 14px

    .filters
        display: flex
        align-items: center
        margin-bottom: 30px

    .sessionHeader
        display: flex
        align-items: center
        justify-content: space-between
        flex-direction: row
        margin: 18px 0 30px

        &.withLogo
            margin: 8px 0 24px

        .titleWrapper h1
            padding-bottom: 0
            margin-bottom: 0
            font-size: remify(40px)
            color: $theme.white
            font-weight: 300

    .businessImageWrapper
        display: flex

    .businessImage
        border-radius: 10px
        overflow: hidden

        img
            width: 65px
            height: 65px

    .clearAllFilters
        opacity: 0.7
        border-radius: 5px

        span
            font-size: 14px

        i
            font-size: 16px

        span
            text-transform: capitalize

    .bottomSpacer
        height: 90px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .titleMinutes
          padding-top: 24px
        .filters
            flex-wrap: wrap

            > div
                width: 50%
                margin-bottom: 5px
                margin-right: 0 !important

        .clearAllFilters
            span
                font-size: 12px
        .createButtonWrapper
            flex-direction: column

            .btn
                margin-bottom: 10px !important
                width: 100%
</style>
